const baseUrl = 'https://mortgage-api.bankrate.com/datadog/v0/ratetable'

const datadogMetrics = {
  defaultTags() {
    return [
      'env:' + window.env,
      'page_slug:' + (window.location.pathname.split('/').slice(-2)[0] ?? false)
    ]
  },

  /**
   * send HISTOGRAM metric | https://docs.datadoghq.com/metrics/types/?tab=histogram#metric-types
   * @param Object metric | {name:String,value:Number,tags:[]}
   * @param String env | default:prod
   * @returns Promise
   */
  async histogram(metric) {
    metric.tags = metric.tags.concat(this.defaultTags())
    return fetch(
      `${baseUrl}/histogram/${metric.name}/${metric.value}/${metric.tags.join(
        ','
      )}`
    )
  },

  /**
   * Increment datadog metric by name
   * @param Object metric | {name:String,value:Number,tags:[]}
   * @param String env | default:prod
   * @returns Promise
   */
  async increment(metric) {
    metric.tags = metric.tags.concat(this.defaultTags())
    return fetch(
      `${baseUrl}/increment/${metric.name}/${metric.value}/${metric.tags.join(
        ','
      )}`
    )
  }
}

export default datadogMetrics
